import {useAppState} from 'store/utils';

export function useIsRefillEnabled(): boolean {
  return useAppState().settings.isRefillEnabled;
}

export function useCoreSettings(): Settings {
  return useAppState().settings;
}
